module.exports = __webpack_public_path__ + "static/keep-pulse.2698aab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/_images/keep-pulse.png
// module id = 671
// module chunks = 114276838955818